export function simpleHash(str: string): string {
  if (str.length === 0) {
    return 'empty';
  }

  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    const char = str.charCodeAt(i);
    /* eslint-disable no-bitwise */
    hash = (hash << 5) - hash + char;
    /* eslint-disable no-bitwise */
    hash &= hash;
  }
  const result = Math.abs(hash).toString(36).substr(0, 6);

  return result;
}
